import infiniteCanvasApi from 'src/api/infiniteCanvas/InfiniteCanvasApi';
import { slice } from 'src/slices/infinite-canvas';
import type { AppThunk } from 'src/store';
import toast from 'react-hot-toast';
import $log from 'src/log/log';
import { handleThunkError } from 'src/utils/auth';

const listInfiniteCanvases =
  (teamId: string): AppThunk =>
  async (dispatch): Promise<void> => {
    try {
      const canvases = await infiniteCanvasApi.list(teamId);
      dispatch(slice.actions.list({ teamId, canvases: canvases.result }));
    } catch (error) {
      if (handleThunkError(error)) {
        // 401 error was handled, don't continue
        return;
      }
      // Handle other errors as needed
      console.error('Error fetching infinite canvases:', error);
    }
  };

const deleteInfiniteCanvas =
  (teamId: string, canvasId: string): AppThunk =>
  async (dispatch): Promise<void> => {
    try {
      const res = await infiniteCanvasApi.delete(teamId, canvasId);
      if (res.ok) {
        dispatch(slice.actions.delete({ teamId, id: canvasId }));
        // get all canvases again
        dispatch(listInfiniteCanvases(teamId));
        toast.success('Canvas deleted');
        return;
      }
      toast.error('Failed to delete canvas');
    } catch (error) {
      if (handleThunkError(error)) {
        // 401 error was handled, don't continue
        return;
      }
      $log.error('Failed to delete canvas', error);
      toast.error('Failed to delete canvas');
    }
  };

const updateInfiniteCanvas =
  (teamId: string, canvasId: string, name: string): AppThunk =>
  async (dispatch): Promise<void> => {
    try {
      const res = await infiniteCanvasApi.update(teamId, canvasId, { name });
      if (res.ok) {
        // Refresh the canvas list to get updated data
        dispatch(listInfiniteCanvases(teamId));
        toast.success('Canvas renamed successfully');
        return;
      }
      toast.error('Failed to rename canvas');
    } catch (error) {
      if (handleThunkError(error)) {
        // 401 error was handled, don't continue
        return;
      }
      $log.error('Failed to rename canvas', error);
      toast.error('Failed to rename canvas');
    }
  };

export const thunks = {
  listInfiniteCanvases: listInfiniteCanvases,
  deleteInfiniteCanvas: deleteInfiniteCanvas,
  updateInfiniteCanvas: updateInfiniteCanvas,
};
